import * as R from 'ramda'
import { StoryRibbon, StoryRibbonPriority } from '$logic/story/types'

export function sortStoryRibbonsBasedOnView(storyRibbons: StoryRibbon[]) {
  const groupedRibbons = R.groupBy(
    ribbon =>
      R.all(item => Boolean(item.viewedAt), ribbon.stories)
        ? 'viewed'
        : 'nonViewed',
    storyRibbons,
  )
  return R.concat(groupedRibbons.nonViewed || [], groupedRibbons.viewed || [])
}

export function getViewedAllStories(stories: StoryRibbon['stories']) {
  return stories.every(item => Boolean(item.viewedAt))
}

export function prioritizeStoryRibbons(
  storyRibbons: StoryRibbon[],
): StoryRibbon[] {
  return storyRibbons.map(storyRibbon => {
    const viewedAll =
      // storyRibbon.viewedAll ||
      getViewedAllStories(storyRibbon.stories)
    return {
      ...storyRibbon,
      priority: viewedAll
        ? StoryRibbonPriority.BASE
        : StoryRibbonPriority.NOT_VIEWED,
    } as StoryRibbon
  })
}

export function sortStoryRibbonsByPriority(storyRibbons: StoryRibbon[]) {
  const groupedBy = R.groupBy(ribbon => String(ribbon.priority), storyRibbons)
  return [
    ...(groupedBy[StoryRibbonPriority.UPLOADING] || []),
    ...(groupedBy[StoryRibbonPriority.NOT_VIEWED] || []),
    ...(groupedBy[StoryRibbonPriority.BASE] || []),
  ]
}
